<script>
	import listBase from '@_system/components/base/list.vue'
	import footerIndex from './footer/index.vue'
	import receiptIndex from './lib/receipt/index.vue'
	import invoiceConfig from '@/components/reports/reconciliationbankflow/lib/invoice/index.vue'
	import configIndex from './lib/config/index.vue'
	export default {
		extends: listBase,
		name: 'collectionIndex',
		props: {

		},
		render(h) {
			this.$slots.mainheader = [
				<el-switch style="padding-left:20px" v-model={this.showUnsendjindie} onChange={this.showUnsendjindieChange} active-text="显示未同步金蝶" inactive-text=""></el-switch>,
			]
			this.$slots.footer = [
				<div style="position: relative;width: 100%;height:100%;">
					<footer-index list={this} ref="footer" row={this.currentrow} />
				</div>
			]
			this.$slots.plug = [
				<config-index ref="collection_configIndex" data={this.configdata} />,
				<receipt-index ref="receiptBox" param={this.param} />,
				<invoiceConfig ref="invoiceConfig" invoicedata={this.invoicedata} tab={this.tab} />
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				configdata:{},
				invoicedata:[],
				tab:[],
				moduleName: 'collection',
				windowName: '收款单',
				showUnsendjindie:0,
				currentrow:null
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			config(){
				this.loading = true
				this.$api.config.get(0,{module:'collection'}).then((res)=>{
					this.configdata = res
					this.$refs.collection_configIndex.modal_show()
					this.loading = false
				},()=>{
					this.loading = false
				})
			},
			invoicepreview(row){
				this.$api.collection.getInvoice({id:row.id}).then((res)=>{
						this.invoicedata = {
							invoiceNumber:res.invoiceNumber,
							customerId:res.customerId,
							invoiceId:res.invoiceId,
							orderId:res.orderId,
							orderPlant:res.orderPlant,
							invoiceType:1
						}
						this.tab = ['invoice']
						this.$nextTick(()=>{
							this.$refs.invoiceConfig.modal_show()
						})
				})
			},
			showUnsendjindieChange(e){
				this.foreingKey.showUnsendjindie = e?1:0
				this.customreload()
			},
			sendjindie(){
				let data =  this.$refs[this.moduleName + '_list'].getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				this.loading = true
				let ids = data.map((item)=>{
					return item.id
				})
				this.$api.collection.sendjindie({ids:ids}).then(()=>{
					this.loading = false
					this.customreload()
				},()=>{
					this.loading = false
				})
				
			},
			beforeRender(){
				this.currentrow = null
			},
			beforeCreateGrid(formConfig, columns,gridOptions) {
				gridOptions.checkboxConfig = null
				columns.unshift({
					type: 'checkbox',
					title: '',
					field:'',
					fixed:'left',
					width:50
				})
				columns.forEach((item)=>{
					
					
					if(item.field=='export_jindie'){
						item.slots = {
							default:({row})=>{
								if(row.export_jindie){
									if(row.export_jindie_sucess == 1){
										return <span style="color:#67C23A;">已同步</span>
									}else{
										if(row.export_jindie_error){
											let error = row.export_jindie_error.map((item)=>{
												return item.Message
											})
											//console.log(row.export_jindie_error)
											return <span style="color:#F56C6C;">{error.join(',')}</span> 
										}else{
											return <span style="color:#F56C6C;">同步失败</span> 
							
										}									
									}
								}else{
									return '未同步'
								}
							}
						}
					}
				})
			},
			afterGet(res){
				res.list.forEach((item)=>{
					let codetag = []
					if(item.invoicestatus==1){
						codetag.push({type:'success',value:'票',content:'已开票'})
					}
					item.extend_tag = [
						{field:'code',tag:codetag},
						// {field:'customercode',tag:customercodetag}
					]
				})
			},
			
			
			cellClick({row}) {
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.footer.inittab()
				})
			},
			receipt(row) {
				this.param = {code:row.code}
				this.$nextTick(()=>{
					this.$refs.receiptBox.modalShow()
				})
				
				
				// let handle = this.$loading()
				// this.$api.paymentapplication.getReceiptInfo({
				// 	supplierwlnid: row.supplierwlnid,
				// 	id: row.id,
				// 	type: row.ordertype
				// }).then((res) => {
				// 	this.receiptInfo = res
				// 	this.$loadingclose(handle)
				// 	this.$refs.receiptBox.modalShow()
					
				// },()=>{
				// 	this.$loadingclose(handle)
				// })
			},
		},
		components: {
			footerIndex,
			receiptIndex,
			invoiceConfig,
			configIndex
		}
	}
</script>